import _reject from 'lodash/reject';
import _first from 'lodash/first';

export const updateObject = <T>(oldObject: T, updatedProperties: Partial<T>): T => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

type MediaType = 'Video' | 'Image';

interface MediaFile {
  Id: string;
  ThumbURL?: string;
  Thumb2URL?: string;
  Thumb3URL?: string;
  Sized1URL?: string;
  w?: number;
  h?: number;
  r?: number;
  o?: number;
  MediaStatus?: string;
  MediaType?: MediaType;
  FileURL?: string;
  MediumImageURL?: string;
  DurationInMs?: number;
}

export const getMediaThumb = (media: MediaFile): string => {
  const thumbs = [media.Thumb3URL, media.Thumb2URL, media.ThumbURL];
  return _first(_reject(thumbs, (t) => !t)) || '';
};

export default {};
